import * as React from 'react'

export const CreatePermissionContext = React.createContext<{
  authorization: boolean
  managePayroll: boolean
}>({ authorization: false, managePayroll: false })
